export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    setMenuOptionList: [
            {
              setMenuIdx : 1,
              sideMenuIdx: 1,
              sideMenuName:"파스타",
              minNum: 1,
              maxNum: 1,
              minmaxYn : true,
              numberYn : false,
              desc : "",
              price : 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 2,
              sideMenuName:"에이드",
              minNum: 0,
              maxNum: 2,
              minmaxYn : true,
              numberYn : true,
              desc : "",
              price : 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 3,
              sideMenuName:"사이드",
              minNum: 0,
              maxNum: 0,
              minmaxYn : false,
              numberYn : true,
              desc : "",
              price : 0,
            },
        ]
    }
}